import EventNote from '@mui/icons-material/EventNote'
import { getBookedSlotStripColorForRoster } from 'src/clinic/components/ClinicManageBookingsPage/DayViewCalendarComponent'
import { BOOKING_STATUSES } from 'src/consumer/constants'
import { getMeetingSrcIcon, getMeetingSrcLabel } from 'src/consumer/helpers/meetingSrcUtils'
import { isSlotBlocked } from 'src/consumer/helpers/utilFunctions'

export default function BookingEventInfoRenderer({ eventInfo }) {
  const fcEvent = eventInfo.event
  const jsEvent = eventInfo.jsEvent

  const type = fcEvent?.extendedProps?.type

  const legendItem = fcEvent?.extendedProps?.legendItem
  const brandName = legendItem?.clinicBrandName
  const brandNameFirstLetter = legendItem?.clinicBrandName?.[0]

  const bookedEventInfo = fcEvent?.extendedProps?.bookedEventInfo
  const slotBlocked = isSlotBlocked(bookedEventInfo)
  const emoji = getBookedSlotStripColorForRoster(bookedEventInfo, slotBlocked).emoji
  return (
    <div
      className="d-flex flex-wrap align-items-start"
      style={{ overflow: 'hidden', height: '100%' }}
    >
      <div
        style={{
          borderRadius: '90px',
          border: '1px solid black',
          aspectRatio: '1',
          width: '22px',
          textAlign: 'center',
        }}
      >
        {brandNameFirstLetter}
      </div>
      <EventNote sx={{ fontSize: '20px' }} />
      {emoji}
      <span title={getMeetingSrcLabel(bookedEventInfo?.meetingSrc)}>
        {getMeetingSrcIcon(bookedEventInfo?.meetingSrc, { size: 20 })}
      </span>
      {bookedEventInfo?.status === BOOKING_STATUSES.BOOKING_INITIATED && <b> ? </b>}
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </div>
  )
}
